module.exports = __webpack_public_path__ + "img/storefront.404973bd.jpg";